import React, { FC, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import Loading from '../../components/common/Loading'

import { postSlackOauth } from "../../../states/apis/slack_oauth"
import { setPath } from "../../../utils/url"
import { URL } from "../../constants/url"
import { useSelector } from "react-redux"
import { RootState } from "../../../states/containers/store"

const SlackCallback: FC = () => {
  const history = useHistory()

  const {
    commonPart,
    login,
  } = useSelector((state: RootState) => (state))

  function useQuery() {
    return new URLSearchParams(useLocation().search)
  }

  const code = useQuery().get('code')

  useEffect(() => {
    if (!login.accessToken) return
    if (code) {
      postSlackOauth(code).then(() => {
        history.push({ pathname: setPath(URL.SETTING_OAUTH.path, commonPart.language as string), state: 'slack_success' })
      }).catch(() => {
        history.push({ pathname: setPath(URL.SETTING_OAUTH.path, commonPart.language as string), state: 'slack_error' })
      })
    } else {
      history.push({ pathname: setPath(URL.SETTING_OAUTH.path, commonPart.language as string), state: 'slack_error' })
    }
  }, [login.accessToken])

  return (
    <>
      <Loading />
    </>
  )
}

export default SlackCallback
